module.exports = __webpack_public_path__ + "img/icon_arrow-karet-big.d80fde74.svg";